import React from 'react';

// Rodapé padrão pra todo modal com botão(ões) de ação — barra inferior com
// borda superior, sangrando até as bordas do painel (compensa o padding
// p-4 sm:p-6 de Modal.js). Um botão só fica centralizado; dois vão pras
// pontas (esquerda/direita) — ex: Cancelar à esquerda, ação principal à
// direita. Mais de dois filhos (raro) cai pra justify-end, sem tentar
// adivinhar um layout melhor.
//
// `semSangria` desliga a sangria até a borda — pra quando o rodapé não é
// mais filho direto do padding do modal (ex: dentro da coluna de conteúdo
// da barra lateral em ConfigurarEnqueteForm.js), onde sangrar "vazaria" pra
// debaixo da barra lateral em vez de até a borda real do modal.
const ModalRodape = ({ children, semSangria = false }) => {
  const itens = React.Children.toArray(children).filter(Boolean);
  const alinhamento = itens.length === 1 ? 'justify-center' : itens.length === 2 ? 'justify-between' : 'justify-end';
  const classesSangria = semSangria
    ? 'border-t border-gray-100 mt-6 pt-4'
    : 'border-t border-gray-100 -mx-4 sm:-mx-6 -mb-4 sm:-mb-6 mt-6 px-4 sm:px-6 py-3.5 sm:py-4';

  return (
    <div className={`flex items-center ${alinhamento} gap-3 ${classesSangria}`}>
      {itens}
    </div>
  );
};

export default ModalRodape;
